/**
 * Konten-Tab der Buchhaltungsseite
 */

import { Plus, RefreshCw, Trash2, Link2, Unlink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { CreditCard } from 'lucide-react';

export function KontenTab({
  konten, bankverbindungen, selectedKlient, selectedKlientName,
  handleSyncBankverbindung, handleDeleteKonto, openChildTab
}) {
  const kontoVerbindung = (kontoId) => bankverbindungen.find(b => b.konto_id === kontoId);

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-sm text-slate-500">{konten.length} Konten für {selectedKlientName?.vorname} {selectedKlientName?.nachname}</p>
        <div className="flex gap-2">
          <Button onClick={() => openChildTab('/schnellerfassung/konto', { title: 'Neues Konto', forceNew: true, params: { klientId: selectedKlient } })} size="sm">
            <Plus className="w-4 h-4 mr-2" /> Konto anlegen
          </Button>
        </div>
      </div>
      {konten.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {konten.map(k => {
            const verbindung = kontoVerbindung(k.id);
            return (
              <Card key={k.id} className="relative">
                <CardContent className="pt-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="font-medium text-slate-800">{k.bezeichnung}</p>
                      <p className="text-sm text-slate-500">{k.bank}</p>
                      {k.iban && <p className="text-xs text-slate-400 font-mono mt-1">{k.iban}</p>}
                      {k.kontostand !== undefined && k.kontostand !== 0 && (
                        <p className={`text-lg font-bold mt-2 ${k.kontostand >= 0 ? 'text-green-700' : 'text-red-700'}`}>
                          {k.kontostand.toLocaleString('de-DE', { minimumFractionDigits: 2 })} €
                        </p>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      {verbindung ? (
                        <Badge variant="default" className="bg-green-600 text-xs">
                          <Link2 className="w-3 h-3 mr-1" /> Verbunden
                        </Badge>
                      ) : null}
                      {k.rechnungslegung_pflicht && (
                        <Badge variant="outline" className="text-xs">RL-Pflicht</Badge>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex gap-2 mt-4 pt-3 border-t border-slate-100">
                    {verbindung ? (
                      <>
                        <Button 
                          variant="outline" 
                          size="sm" 
                          onClick={() => handleSyncBankverbindung(verbindung.id)}
                          data-testid={`btn-sync-${k.id}`}
                        >
                          <RefreshCw className="w-4 h-4 mr-1" /> Sync
                        </Button>
                        <Button 
                          variant="ghost" 
                          size="sm"
                          onClick={() => handleSyncBankverbindung(verbindung.id, true)}
                        >
                          <Unlink className="w-4 h-4 mr-1" /> Trennen
                        </Button>
                      </>
                    ) : (
                      <Button 
                        variant="outline" 
                        size="sm"
                        onClick={() => openChildTab('/schnellerfassung/finapi', { title: 'Bank verbinden', forceNew: true, params: { klientId: selectedKlient, konto: k } })}
                        data-testid={`btn-connect-${k.id}`}
                      >
                        <Link2 className="w-4 h-4 mr-1" /> Bank verbinden
                      </Button>
                    )}
                    <Button variant="ghost" size="sm" onClick={() => handleDeleteKonto(k.id)}>
                      <Trash2 className="w-4 h-4 text-slate-400" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      ) : (
        <Card><CardContent className="py-8 text-center text-slate-500">Keine Konten angelegt</CardContent></Card>
      )}
    </div>
  );
}
